//////////////////////////////////////////////////////////////////////////////
//
//  Dashboard API
//
//  작성자: MediInStep Team
//  생성일: 2025-12-26
//
//  설명: 대시보드 통계 및 차트 데이터 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

export interface DashboardStats {
    // User metrics
    totalUsers: number;
    newUsersToday: number;
    activeUsersToday: number;
    inactiveUsers: number;

    // Trend data (day-over-day changes)
    newUsersTrend?: number;

    // Point economy
    totalPointsIssued: number;
    totalPointsUsed: number;
    circulatingPoints: number;
    pendingUseRequests: number;

    // Point trends (day-over-day changes)
    totalPointsIssuedTrend?: number;
    totalPointsUsedTrend?: number;

    // Activity tracking
    totalStepsToday: number;
    averageStepsPerUser: number;
    goalAchievementRate: number;

    // Video rehabilitation
    videoCompletionsToday: number;
    averageCompletionRate: number;
    topVideos: TopVideo[];
}

export interface TopVideo {
    seqId: number;
    title: string;
    completionCount: number;
}

export interface UserGrowth {
    date: string;
    newUsers: number;
    cumulativeUsers: number;
}

export interface PointEconomy {
    date: string;
    pointsIssued: number;
    pointsUsed: number;
}

export interface UserSegment {
    segment: string;
    userCount: number;
    percentage: number;
}

export interface AnalyticsDataset {
    label: string;
    data: number[];
}

export interface AnalyticsChartData {
    labels: string[];
    datasets: AnalyticsDataset[];
}

export interface UserAnalytics {
    dailyData: AnalyticsChartData;
    monthlyData: AnalyticsChartData;
    dailyOfMonthData: AnalyticsChartData;
}

export interface PointAnalytics {
    dailyData: AnalyticsChartData;
    monthlyData: AnalyticsChartData;
    dailyOfMonthData: AnalyticsChartData;
}

export interface StepAnalytics {
    dailyData: AnalyticsChartData;
    monthlyData: AnalyticsChartData;
    dailyOfMonthData: AnalyticsChartData;
}

/**
 * 대시보드 관련 API
 */
export const DashboardAPI: ApiGroup = {
    getStats: {
        title: "대시보드 통계 조회",
        url: "/Dashboard/stats",
        method: "GET",
        paramz: {},
    },
    getUserGrowth: {
        title: "사용자 성장 추이 조회",
        url: "/Dashboard/user-growth",
        method: "GET",
        paramz: { days: 30 },
    },
    getPointEconomy: {
        title: "포인트 경제 추이 조회",
        url: "/Dashboard/point-economy",
        method: "GET",
        paramz: { days: 30 },
    },
    getUserSegments: {
        title: "사용자 세그먼트 조회",
        url: "/Dashboard/user-segments",
        method: "GET",
        paramz: {},
    },
    getUserAnalytics: {
        title: "사용자 분석 데이터 조회",
        url: "/Dashboard/user-analytics",
        method: "GET",
        paramz: {},
    },
    getPointAnalytics: {
        title: "포인트 분석 데이터 조회",
        url: "/Dashboard/point-analytics",
        method: "GET",
        paramz: {},
    },
    getStepAnalytics: {
        title: "걸음수 분석 데이터 조회",
        url: "/Dashboard/step-analytics",
        method: "GET",
        paramz: {},
    },
}
